/**
 * Maximal period (in milliseconds) that bulk sending could be resumed after paused
 */
export const BULK_SEND_PAUSE_MAX_MS = 1000 * 60 * 60 * 3; // 3 hours

export * from './interfaces';
